import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../../settings/const";

export default class SharepointSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Sharepoint",
            description              : "",
            svgIcon                  : "isvg-sharepoint-integration",
            settingsUrl              : "settings/integrations/sharepoint",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integrations"

        });

        this.parentSection          = SettingsParentSection.INTEGRATIONS
    }

}
